import { useEffect } from 'react';

/** Tracking clicks for Matomo
 *  
    Any combinations of the four follwing attributes except data-event category, which 
    is mandatory, can be added to an element in the following way:
    
    import useWindowLocationHref from '../Hooks/useWindowLocation';
    const href = useWindowLocationHref();

    <div>
      <div 
        data-event-category={href || 'novalue'}
        data-event-action="some text"
        data-event-name="name"
        data-event-value="">
        <a data-event-include ></a>
      </div>
    </div>
    Due to limitations in SSR, you cannot use window.location.href due to window being undefined.
    If you need to track window.location.href it should be done in combination with the useWindowLocationHref hook. 
      
    The above attributes should have corresponding Data-Layer variables in Matomo 
    and will receive the values of the attribute. The variables needs to be attached
    to a tag and trigger which responds to pushed events. The trigger 
    Event Name value must match the event name pushed in _mtm.push below.
    Place <MatomoTrackDataAttribute />  on the page you want to track.
    The attribute data-event-include may be used on child elements, clicks on them 
    will pass the data-event values of the closest parent holding 
    the data-event-category attribute:

    <div>
      <div 
        data-event-category={href || 'novalue'}
        data-event-action="action"
        data-event-name="name"
        data-event-value="val">
        <a data-event-include>
          <span data-event-include></span
        </a>
      </div> 
    </div
 */

const MatomoTrackDataAttribute = () => {
  useEffect(() => {
    const locateAttribute = (event) => {
      if (event?.target?.getAttribute('data-event-category') != null) {
        sendEventData(event.target);
      } else if (event?.target?.getAttribute('data-event-include') != null) {
        sendEventData(event.target.closest('[data-event-category]'));
      }
    };

    const sendEventData = (elem) => {
      var _mtm = (window._mtm = window?._mtm || []);
      let action = 'Klick';
      if (elem?.getAttribute('data-event-action') != null) {
        action = elem.getAttribute('data-event-action');
      }
      let name = '';
      if (elem?.getAttribute('data-event-name') != null) {
        name = elem.getAttribute('data-event-name');
      }
      let value = 0;
      if (elem?.getAttribute('data-event-value') != null) {
        value = elem.getAttribute('data-event-value');
      }

      _mtm.push({
        event: 'clickEvent',
        eventCategory: elem.getAttribute('data-event-category'),
        eventAction: action,
        eventName: name,
        eventValue: value,
      });
    };

    document?.documentElement?.addEventListener('click', locateAttribute, true);

    return () => {
      document?.documentElement?.removeEventListener(
        'click',
        locateAttribute,
        true
      );
    };
  }, []);

  return null;
};
export default MatomoTrackDataAttribute;
